// extracted by mini-css-extract-plugin
module.exports = {"promotionalTilesComponent":"r-","promotionalTile":"r_","promotionalTileThumb":"sa","promotionalTileHeader":"sb","promotionalTileCaption":"sc"};